var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";

function IconPhone(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M16.1 13.35c-.2-.47-2.8-1.21-2.98-1.3h-.2c-.36.18-.74.46-1.57 1.2a13.38 13.38 0 01-2.8-2.23 9.69 9.69 0 01-1.67-2.79c.93-.84 1.3-1.21 1.3-1.58 0-.19-.46-2.89-.93-3.17l-.1-.09c-.27-.19-.64-.46-1.2-.37-.1 0-.19.1-.37.18-.28.2-1.12.75-1.5 1.5-.18.46-.36 4.65 2.8 8.18 3.07 3.54 6.98 3.63 7.54 3.54h.1c.74-.28 1.39-1.02 1.67-1.3.46-.56.09-1.21 0-1.58l-.1-.2z"
  }));
}

export default IconPhone;